<script setup>

</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 852.4 852.4"><rect width="852.4" height="852.4" rx="72.71" style="fill: rgb(35, 165, 102);"></rect><path d="M654.74,624.11H197.66V228.29H654.74V624.11ZM454.47,284.83v70.69H598.19V284.83Zm0,113.1v66H598.19v-66Zm0,108.38v61.26H598.19V506.31Zm-56.55,61.26V506.31H254.21v61.26Zm0-103.67v-66H254.21v66Zm0-108.38V284.83H254.21v70.69Z" style="fill: rgb(255, 255, 255); fill-rule: evenodd;"></path></svg>
</template>
